export const INTEGRATION_NAME_MAX_LENGTH = 30;

type TruncateText = (text: string, maxLength: number) => string;

export const getIntegrationDisplayName = (
  name: string | null | undefined,
  truncateText: TruncateText,
): string => (name ? truncateText(name, INTEGRATION_NAME_MAX_LENGTH) : '—');
